import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const CookiePolicy: React.FC = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    document.title = 'Cookie Policy | ECORIDE Electric Bicycles';
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-8">
        <button
          onClick={() => navigate('/')}
          className="flex items-center text-primary hover:text-primary-dark mb-8 transition-colors"
        >
          <ArrowLeft size={20} className="mr-2" />
          Back to Home
        </button>

        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-lg p-8">
          <h1 className="text-3xl font-bold text-gray-800 mb-6">Cookie Policy</h1>
          
          <div className="prose max-w-none text-gray-600">
            <p className="mb-4">Last updated: March 15, 2024</p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">1. What Are Cookies</h2>
              <p className="mb-4">
                Cookies are small text files that are placed on your computer or mobile device when you visit our website. They help us make your experience better by:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Remembering your preferences</li>
                <li>Understanding how you use our website</li>
                <li>Improving site functionality</li>
                <li>Personalizing content for you</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Types of Cookies We Use</h2>
              <div className="mb-4">
                <h3 className="text-xl font-semibold mb-2">Essential Cookies</h3>
                <p className="mb-4">
                  These cookies are necessary for the website to function properly. They enable basic functions like page navigation and access to secure areas of the website.
                </p>

                <h3 className="text-xl font-semibold mb-2">Preference Cookies</h3>
                <p className="mb-4">
                  These cookies remember your preferences and settings to enhance your experience on future visits.
                </p>

                <h3 className="text-xl font-semibold mb-2">Analytics Cookies</h3>
                <p className="mb-4">
                  These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Managing Cookies</h2>
              <p className="mb-4">
                You can control and/or delete cookies as you wish. You can delete all cookies that are already on your computer and you can set most browsers to prevent them from being placed.
              </p>
              <p className="mb-4">
                To modify your cookie settings, you can:
              </p>
              <ul className="list-disc pl-6 mb-4">
                <li>Use our cookie consent banner</li>
                <li>Adjust your browser settings</li>
                <li>Delete existing cookies through your browser settings</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Specific Cookies We Use</h2>
              <div className="overflow-x-auto">
                <table className="w-full mb-4">
                  <thead>
                    <tr className="bg-gray-100">
                      <th className="p-2 text-left">Cookie Name</th>
                      <th className="p-2 text-left">Purpose</th>
                      <th className="p-2 text-left">Duration</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="p-2 border-t">cookie_consent</td>
                      <td className="p-2 border-t">Stores your cookie preferences</td>
                      <td className="p-2 border-t">1 year</td>
                    </tr>
                    <tr>
                      <td className="p-2 border-t">user_name</td>
                      <td className="p-2 border-t">Remembers your name for forms</td>
                      <td className="p-2 border-t">7 days</td>
                    </tr>
                    <tr>
                      <td className="p-2 border-t">user_email</td>
                      <td className="p-2 border-t">Remembers your email for forms</td>
                      <td className="p-2 border-t">7 days</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Contact Us</h2>
              <p className="mb-4">
                If you have questions about our Cookie Policy, please contact us at:
              </p>
              <p className="mb-4">
                Email: privacy@ecoride.com<br />
                Phone: (555) 123-4567<br />
                Address: 123 Electric Avenue, San Francisco, CA 94103
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy;